import React from 'react';
import { ImageConverter } from '../components/image-converter/ImageConverter';
import '../components/image-converter/ImageConverter.css';

export const ImageConverterPage: React.FC = () => {
  return (
    <div className="page-container">
      <ImageConverter />
    </div>
  );
};
